import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsISO8601, IsNumber, IsUUID } from 'class-validator';
import { JobPhaseBumpInterface } from '../interfaces/job-phase-bump.interface';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { JobPhaseBumpCommonDto } from './job-phase-bump-common.dto';
import { JobPhaseBumpNoteDto } from '../../job-phase-bump-note/dto/job-phase-bump-note.dto';
import { JobPhaseBumpNoteInterface } from '../../job-phase-bump-note/interfaces/job-phase-bump-note.interface';
import { JobPhaseBumpPhotoDto } from '../../job-phase-bump-photo/dtos/job-phase-bump-photo.dto';
import { JobPhaseBumpPhotoInterface } from '../../job-phase-bump-photo/interfaces/job-phase-bump-photo.interface';
import { UserDto } from '../../user/dto/user.dto';

@Exclude()
export class JobPhaseBumpDto
  extends JobPhaseBumpCommonDto
  implements JobPhaseBumpInterface
{
  @ApiProperty({
    title: 'Date',
    type: 'string',
    format: 'date-time',
  })
  @IsISO8601({ strict: true })
  @Expose()
  date!: Date;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Contractor ID',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'Job Phase',
    description: 'The Job Phase associated with this Job Phase Bumper ',
  })
  @Expose()
  jobPhase?: JobPhaseDto;

  @ApiPropertyOptional({
    type: () => ContractorDto,
    title: 'Contractor',
    description: 'The Contractor associated with this Job Phase Bumper ',
  })
  @Expose()
  contractor?: ContractorDto;

  @ApiPropertyOptional({
    type: () => [JobPhaseBumpNoteDto],
    title: 'Job Phase Bump Notes',
    description:
      'The Job Phase Bump Notes associated with this job phase bump.',
  })
  @Expose()
  jobPhaseBumpNotes?: JobPhaseBumpNoteInterface[];

  @ApiPropertyOptional({
    type: () => [JobPhaseBumpPhotoDto],
    title: 'Job Phase Bump Photos',
    description:
      'The Job Phase Bump Photos associated with this job phase bump.',
  })
  @Expose()
  jobPhaseBumpPhotos?: JobPhaseBumpPhotoInterface[];

  @ApiProperty({
    title: 'currentCost',
    description: 'CurrentCost of this payment',
  })
  @IsNumber()
  @Expose()
  currentCost!: number | null;

  @ApiProperty({
    title: 'Check',
    nullable: true,
  })
  @Expose()
  check!: string;

  @ApiProperty({
    format: 'uuid',
    description:
      'The initial supervisor user id at time of job repair creation.',
    nullable: true,
  })
  @IsUUID()
  @Expose()
  originalSupervisorUserId!: string;

  @ApiProperty({
    type: () => UserDto,
    description: 'The initial supervisor user at time of job repair creation.',
  })
  @Expose()
  originalSupervisorUser?: UserDto;
}
